import { convertToEnglishDigit } from "../../helpers/Functions";
import ApiService from "./ApiService";

class AdminApiService extends ApiService {
  /**
   *
   * @param {string} phone
   * @returns {Promise}
   */
  async searchUser(phone) {
    try {
      const res = await this.axios.get(
        `admins/users?phone=${convertToEnglishDigit(phone)}`
      );
      return res.data;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   * @param {number} providerId
   * @param {number} phone
   * @returns {Promise}
   */
  async addEmployee(providerId, phone) {
    try {
      const res = await this.axios.post(
        `providers/${providerId}/users/${convertToEnglishDigit(
          phone
        )}/employees`
      );
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   * @param {number} providerId
   * @param {number} userId
   * @returns {Promise}
   */
  async deleteEmployee(providerId, phone) {
    try {
      const res = await this.axios.delete(
        `providers/${providerId}/users/${convertToEnglishDigit(
          phone
        )}/employees`
      );
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   * @returns {Promise}
   */
  async getAllAbilities() {
    try {
      const res = await this.axios.get(`admins/abilities`);
      return res;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }
}

const adminApiService = new AdminApiService();
export default adminApiService;
